import { Mail, CheckCircle } from 'lucide-react';
import React, { useState } from 'react';

import './Footer.css';
import { buildApiUrl } from '../config/api';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [message, setMessage] = useState('');

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch(`${buildApiUrl('')}/newsletter/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (data.success) {
        setSubscribed(true);
        setMessage("Thanks for your interest, you'll be hearing from us soon");
        setEmail('');
        // Reset after 5 seconds
        setTimeout(() => {
          setSubscribed(false);
          setMessage('');
        }, 5000);
      } else {
        setMessage(data.message || 'Something went wrong');
      }
    } catch (err) {
      setMessage('Failed to subscribe. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-simple">
          {/* Left: Brand */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img
                src="/gatherpilot-logo.svg"
                alt="GatherPilot Logo"
                style={{ width: '32px', height: '32px', objectFit: 'contain' }}
              />
              <span>GatherPilot</span>
            </div>
            <p className="footer-description">
              Discover experiences, events, and activities that help you live life to the fullest.
            </p>
          </div>

          {/* Middle: Newsletter */}
          <div className="footer-newsletter">
            <h4>Stay in the loop</h4>
            <p>Get the latest experiences and adventures in your inbox</p>
            {subscribed ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#4CAF50' }}>
                <CheckCircle size={24} />
                <span>{message}</span>
              </div>
            ) : (
              <>
                <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    className="newsletter-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                    required
                  />
                  <button type="submit" className="newsletter-btn" disabled={loading || !email}>
                    {loading ? '...' : <Mail size={20} />}
                  </button>
                </form>
                {message && !subscribed && (
                  <p style={{ color: '#f44336', fontSize: '14px', marginTop: '5px' }}>{message}</p>
                )}
              </>
            )}
          </div>

          {/* Right: Copyright */}
          <div className="footer-copyright">
            <p>
              &copy; 2025 GatherPilot. All rights reserved.{' '}
              <a href="/privacy" style={{ color: 'inherit', textDecoration: 'underline' }}>
                Privacy Policy
              </a>
            </p>
            <p>Made with ❤️ for people who want to gather and connect</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
